@if (vendor && marketplace) {
  <img src="assets/images/marketplace/marketplace-icon.png" data-toggle="tooltip" data-placement="right"
    title="{{'marketplace.title' | cxTranslate}}: {{ vendor.name }}" />
    @if (displayText) {
      <span>{{'marketplace.title' | cxTranslate}}: {{ vendor.name }}</span>
    }
  }